import { theme } from 'aimo-ui';
import { Dimensions, StyleSheet } from 'react-native';

export const clusterStyles = [
  {
    textColor: theme.colors.white,
    url: '/images/circle.svg',
    height: 50,
    width: 50,
  },
  {
    textColor: theme.colors.white,
    url: '/images/circle.svg',
    height: 50,
    width: 50,
  },
  {
    textColor: theme.colors.white,
    url: '/images/circle.svg',
    height: 50,
    width: 50,
  },
];

export const webSheetStyles = StyleSheet.create({
  sheetOuter: {},
  lineContainer: { display: 'none' },
  sheetWrapper: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    flex: 1,
  },
  sheetInner: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    marginTop: 20,
    height: 11500,
    overflow: 'hidden',
    backgroundColor: theme.colors.white,
  },
});

export const webNavigationStyle = StyleSheet.create({
  backgroundContainer: {
    backgroundColor: theme.colors.white,
    flex: 1,
  },
  tabContainer: {
    borderBottomWidth: 0.5,
    borderTopWidth: 0,
    borderColor: 'rgba(0,0,0,0.33)',
    minHeight: 80,
  },
  tabContainerMobile: {
    paddingTop: 15,
  },
  label: {
    lineHeight: 12,
    fontSize: 12,
    fontFamily: theme.fontFamily.medium,
  },
  labelMobile: {
    marginTop: 3,
  },
});

export const navigationHeight = theme.normalising.heightPixel(78);
export const navigationStyle = StyleSheet.create({
  backgroundContainer: {
    backgroundColor: theme.colors.lightBg.pink,
    flex: 1,
  },
  tabContainer: {
    position: 'absolute',
    borderTopWidth: 0.5,
    borderColor: 'rgba(0,0,0,0.33)',
    alignItems: 'center',
    minHeight: navigationHeight,
    justifyContent: 'flex-start',
    alignContent: 'center',
    // paddingHorizontal: 10,
    paddingTop: 10,
  },
  label: {
    marginTop: 10,
    lineHeight: 12,
    fontSize: 12,
    fontFamily: theme.fontFamily.medium,
    alignSelf: 'center',
    justifyContent: 'flex-start',
  },
  tab: { marginBottom: 0 },
});

export const mapStyles = (navBarHeight = 0) =>
  StyleSheet.create({
    mapView: {
      width: Dimensions.get('window').width,
      height: Dimensions.get('window').height,
    },
    mapPadding: {
      bottom: Dimensions.get('window').height * 0.45 + navBarHeight,
      top: 0,
      right: 0,
      left: 0,
    },
    mapButton: { elevation: 20 },
    markerView: {
      transform: [{ scale: 0.8 }, { translateY: 16.5 }],
    },
    selectedMarkerView: {
      overflow: 'hidden',
      transform: [{ scale: 1 }, { translateY: 0 }],
    },
  });

export const sheetStyles = StyleSheet.create({
  container: {
    shadowOffset: {
      width: 0,
      height: 8,
    },
    shadowOpacity: 0.45,
    shadowRadius: 7,
    elevation: 10,
    // Top corners only: the sheet bottom sits at the screen edge, and a
    // rounded bottom shows above the transparent nav bar on Android 15+.
    borderTopLeftRadius: 45,
    borderTopRightRadius: 45,
    backgroundColor: theme.colors.white,
    shadowColor: theme.colors.black,
  },
  flexOne: {
    flex: 1,
  },
  fullHeight: {
    height: '100%',
  },
});

export const sheetModalStyles = StyleSheet.create({
  backdrop: {
    zIndex: 0,
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
});
